import moment from "moment";
import React, { useEffect, useRef, useState } from "react";

const Calendar = ({ daysArray, selectedDate, setSelectedDay }) => {
  const [currentDate, setCurrentDate] = useState();
  const selectedDateRef = useRef(null);
  const scrollRef = useRef(null);
  console.log("selectedDate: ", selectedDate);
  useEffect(() => {
    setCurrentDate(selectedDate);
    if (selectedDateRef.current) {
      selectedDateRef.current.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "center",
      });
    }
  }, [currentDate, selectedDate]);

  const handleClick = (val) => {
    setSelectedDay(val);
  };

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -150, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 150, behavior: "smooth" });
    }
  };

  return (
    <div className="relative md:px-6 lg:px-10">
      {/* Left arrow */}
      <button
        onClick={scrollLeft}
        className="hidden md:flex items-center justify-center absolute left-0 top-1/2 transform -translate-y-1/2 w-8 h-8 bg-white rounded-full shadow hover:bg-gray-100 z-10"
      >
        &#8592;
      </button>
      <div
        ref={scrollRef}
        className="flex justify-start  rounded-lg overflow-x-scroll mx-auto py-1 px-2  md:mx-16 md:px-10 scrollbar-hide"
      >
        {daysArray.map((date) => (
          <React.Fragment key={date}>
            {moment(selectedDate).format("L") !== moment(date).format("L") ? (
              <div
                class="flex group hover:bg-slate-200 hover:shadow-lg hover-light-shadow rounded-lg mx-1 transition-all duration-300 cursor-pointer justify-center w-16"
                ref={
                  moment(selectedDate).format("L") === moment(date).format("L")
                    ? selectedDateRef
                    : null
                }
                onClick={() => handleClick(date)}
              >
                <div class="flex items-center px-4 py-4">
                  <div class="text-center">
                    <p class="text-gray-900 group-hover:text-black text-md transition-all duration-300">
                      {" "}
                      {moment(date).format("ddd")}{" "}
                    </p>
                    <p class="text-gray-900 group-hover:text-black mt-3 group-hover:font-bold transition-all duration-300">
                      {" "}
                      {moment(date).format("DD")}{" "}
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="flex group bg-[#eaf3fa] shadow-9 light-shadow rounded-lg mx-1 cursor-pointer justify-center relative w-16 content-center"
                ref={selectedDateRef}
              >
                <span class="flex h-3 w-3 absolute -top-1 -right-1">
                  <span class="animate-ping absolute group-hover:opacity-75 opacity-0 inline-flex h-full w-full rounded-full bg-annual"></span>
                  <span class="relative inline-flex rounded-full h-3 w-3 bg-annual border border-[#eaf3fa]"></span>
                </span>
                <div class="flex items-center px-4 py-4">
                  <div class="text-center">
                    <p class="text-black text-lg font-semibold">
                      {" "}
                      {moment(date).format("ddd")}{" "}
                    </p>
                    <p class="text-black mt-3 font-bold">
                      {" "}
                      {moment(date).format("DD")}{" "}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
      {/* Right arrow */}
      <button
        onClick={scrollRight}
        className="hidden md:flex items-center justify-center absolute right-0 top-1/2 transform -translate-y-1/2 w-8 h-8 bg-white rounded-full shadow hover:bg-gray-100 z-10"
      >
        &#8594;
      </button>
    </div>
  );
};

export default Calendar;
